import { DynamicQueryEvent, DynamicQueryEventFactory, DynamicQueryEventTypes } from './dynamic-query-events.factory';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { DynamicQueryManagerService } from 'common/dynamicquery/dynamic-query-manager.service';
import { DynamicQuery } from './dynamic-query-class';
import { DynamicQueryObservable } from './dynamic-query-observable.model';

@Injectable()
export class DynamicQueryAdapterService {
  constructor(private _dynamicQueryManager: DynamicQueryManagerService) {
  }

  /**
   * Get RxJs Observable to a Bold Dynamic Query
   *  @param {string} queryName
   *  @param {object} queryParams
   *  @return {Observable}
   * */
  public getQuery(queryName, queryParams?): DynamicQueryObservable<any> {
    const queryParamsObj = queryParams || {};

    if (!queryName) {
      throw new Error('Missing queryName parameter');
    }

    return new Observable<DynamicQueryEvent>(subscriber => {
      let dyn: DynamicQuery;

      function createHandler(event) {
        return function returnedCreateHandlerFunc(data?) {
          subscriber.next(DynamicQueryEventFactory.createEvent(event, data));
        };
      }

      const doneHandler = createHandler(DynamicQueryEventTypes.DONE);
      const updatedHandler = createHandler(DynamicQueryEventTypes.UPDATED);
      const deletedHandler = createHandler(DynamicQueryEventTypes.DELETED);
      const insertedHandler = createHandler(DynamicQueryEventTypes.INSERTED);

      function setUpListeners(_dyn_: DynamicQuery) {
        dyn = _dyn_;
        if (dyn.isDone()) {
          dyn.iterate(item => insertedHandler(item));
          doneHandler();
        }
        dyn.addListener(DynamicQueryEventTypes.DONE, doneHandler);
        dyn.addListener(DynamicQueryEventTypes.UPDATED, updatedHandler);
        dyn.addListener(DynamicQueryEventTypes.DELETED, deletedHandler);
        dyn.addListener(DynamicQueryEventTypes.INSERTED, insertedHandler);
      }

      function handleError(error) {
        subscriber.error(error);
      }

      this._dynamicQueryManager.query(queryName, queryParamsObj).then(setUpListeners, handleError);

      return function disposer() {
        if (dyn) {
          dyn.removeListener(DynamicQueryEventTypes.DONE, doneHandler);
          dyn.removeListener(DynamicQueryEventTypes.UPDATED, updatedHandler);
          dyn.removeListener(DynamicQueryEventTypes.DELETED, deletedHandler);
          dyn.removeListener(DynamicQueryEventTypes.INSERTED, insertedHandler);
          dyn.close();
        }
      };
    });
  }
}
